// @flow
import validator from "validator";

type valuesType = {
  firstName?: string,
  lastName?: string,
  email?: string,
};

type errorsType = {
  firstName?: string,
  lastName?: string,
  email?: string,
};

const validateAdd = (values: valuesType): errorsType => {
  const errors = {};

  if (!values.firstName) {
    errors.firstName = "Required";
  }

  if (!values.lastName) {
    errors.lastName = "Required";
  }

  if (!values.email) {
    errors.email = "Required";
  }

  if (values.email && !validator.isEmail(values.email)) {
    errors.email = "Invalid email address";
  }

  return errors;
};

export default validateAdd;
